import { render, staticRenderFns } from "./TransferDetailModal.vue?vue&type=template&id=e77d9f9a&"
import script from "./TransferDetailModal.vue?vue&type=script&lang=ts&"
export * from "./TransferDetailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports